import { Hind } from 'next/font/google';

/**
 * Hind, the primary typeface ($primaryFontFamily).
 *
 * next/font downloads the files at build time and serves them from our own
 * origin, so there is no request to fonts.googleapis.com at runtime and no
 * render-blocking chain before the text can paint. It also generates a
 * size-adjusted local fallback, which removes the layout shift as the webfont
 * swaps in.
 *
 * Nothing should refer to the family by name: what next/font emits is an
 * implementation detail of the bundler (Turbopack keeps "Hind", webpack mangles
 * it to __Hind_<hash>) and it pairs the face with a generated fallback that a
 * bare "Hind" would miss. `variable` exposes the whole stack as --font-hind
 * instead; _document puts that on <html> and the stylesheets reach it through
 * $primaryFontFamily.
 */
export const hind = Hind({
  subsets: ['latin'],
  weight: ['400', '500', '600', '700'],
  display: 'swap',
  variable: '--font-hind',
});

export default hind;
